module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "display": "flex",
      "flex-wrap": "wrap"
    }
  }, [(_vm.showInvoiceBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('goToInvoice')
      }
    }
  }, [_vm._v("开票信息")]) : _vm._e(), _vm._v(" "), (_vm.showCustomerGoodsBtn) ? _c('div', {
    staticClass: "common-btn research-font-color",
    on: {
      "click": function($event) {
        return _vm.$emit('goToCustomerGoods')
      }
    }
  }, [_vm._v("实物信息")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1fef93ac","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/emktcommon/orders/order/components/GcOrderDetailButtonsBase.vue
// module id = 1562
// module chunks = 8